module.exports = __webpack_public_path__ + "img/new.cbfef3eb.png";